<template>
    <slot name="product_filter" v-bind="this"></slot>
</template>

<script>
export default {
    props: {
        filter: { type: Array, default: () => [] },
        endpoint: { type: String, default: '/' },
        timer: { type: String, default: '1000' }
    },
    data() {
        return {
            localFilter: JSON.parse(JSON.stringify(this.filter)),
            sendLock: false
        };
    },
    watch: {
        filter: {
            handler(newVal) {
                this.localFilter = JSON.parse(JSON.stringify(newVal));
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleFilterUpdate(updatedCategory) {
            const index = this.localFilter.findIndex(
                (category) => category.title === updatedCategory.title
            );
            if (index !== -1) {
                this.localFilter[index] = { ...updatedCategory };
                this.applyFilter();
            }
        },

        applyFilter() {

            this.localFilter.forEach(category => {

                const rangeFilter = category.filters.find(f => f.type === 'range');
                const selectorFilter   = category.filters.find(f => f.type === 'selector');

                if (rangeFilter && selectorFilter) {

                const min = rangeFilter.options?.[0]?.value;
                const max = rangeFilter.options?.[1]?.value;

                    if (min != null || max != null) {
                        selectorFilter.options.forEach(opt => {
                        opt.checked = false;
                        });
                    }
                }
                
            });

            const activeFilters = {};

            this.localFilter.forEach((category) => {
                if (category.filters) {
                    category.filters.forEach((filter) => {
                        switch (filter.type) {
                            case 'multiselector':
                                filter.options.forEach((option) => {
                                    if (option.checked) {
                                        const categoryName = filter.name;
                                        if (!activeFilters[categoryName]) {
                                            activeFilters[categoryName] = { value: [] };
                                        }
                                        activeFilters[categoryName].value.push(option.value);
                                    }
                                });
                            break;
                            case 'multioptions':
                                if (!activeFilters[filter.name]) {
                                    activeFilters[filter.name] = { top: [], subs: {} };
                                }
                                filter.options.forEach((option) => {
                                    let hasSubChecked = false;
                                    if (Array.isArray(option.suboptions)) {
                                        option.suboptions.forEach(suboption => {
                                            if (suboption.checked) {
                                                hasSubChecked = true;
                                                if (!activeFilters[filter.name].subs[option.value]) {
                                                    activeFilters[filter.name].subs[option.value] = [];
                                                }
                                                activeFilters[filter.name].subs[option.value].push(suboption.value);
                                            }
                                        });
                                    }
                                    if (option.checked || hasSubChecked) {
                                        if (!activeFilters[filter.name].top.includes(option.value)) {
                                            activeFilters[filter.name].top.push(option.value);
                                        }
                                    }
                                });
                            break;
                            case 'range': {
                                const min = filter.options?.[0]?.value;
                                const max = filter.options?.[1]?.value;
                                if (min !== null || max !== null) {
                                    const categoryName = filter.name;
                                    let value = '';
                                    if (min !== null && max !== null) {
                                        value = `${min}-${max}`;
                                    } else if (min !== null) {
                                        value = `${min}-`;
                                    } else if (max !== null) {
                                        value = `-${max}`;
                                    }
                                    if (value) {
                                        activeFilters[categoryName] = { value };
                                    }
                                }
                            break;
                            }
                            case 'selector':
                                filter.options.forEach((option) => {
                                    if (option.checked) {
                                        const categoryName = filter.name;
                                        activeFilters[categoryName] = { value: option.value };
                                    }
                                });
                                break;
                            case 'checkbox':
                                if (filter.value === true) {
                                    const categoryName = filter.name;
                                    activeFilters[categoryName] = { value: true };
                                }
                            break;
                        }
                    });
                }
            });

            const urlParams = new URLSearchParams(window.location.search);
            this.localFilter.forEach(category => {
                const rangeF = category.filters.find(f => f.type === 'range');
                if(rangeF) {
                    const key = rangeF.name;
                    if(!activeFilters[key] && urlParams.has(key)) {
                        activeFilters[key] = {value: urlParams.get(key)};
                    }
                }
            })

            

            const payload = this.sendFilters(activeFilters);
            this.send(payload);
        },

        sendFilters(activeFilters) {
            const params = [];
            for (const category in activeFilters) {
                const data = activeFilters[category];
                if (data.hasOwnProperty('top') && data.hasOwnProperty('subs')) {
                    if (Array.isArray(data.top) && data.top.length) {
                        data.top.forEach(val => {
                            params.push(`${category}[]=${encodeURIComponent(val)}`);
                        });
                    }
                    if (data.subs) {
                        for (const parentVal in data.subs) {
                            data.subs[parentVal].forEach(subVal => {
                                params.push(`${category}[${parentVal}][]=${encodeURIComponent(subVal)}`);
                            });
                        }
                    }
                } else {
                    const values = data.value;
                    if (Array.isArray(values)) {
                        values.forEach(value => {
                            params.push(`${category}[]=${encodeURIComponent(value)}`);
                        });
                    } else if (
                        values !== null && typeof values === 'object' &&
                        ('min' in values || 'max' in values)
                    ) {
                        if (values.min !== undefined && values.min !== null) {
                            params.push(`${category}[min]=${values.min}`);
                        }
                        if (values.max !== undefined && values.max !== null) {
                            params.push(`${category}[max]=${values.max}`);
                        }
                    } else {
                        if(values !== undefined && values !== null) {
                            params.push(`${category}=${encodeURIComponent(values)}`);
                        }
                    }
                }
            }
            return '?' + params.join('&');
        },

        send(payload) {
            if (window.location.search === payload) {
                return;
            }
            if (this.sendLock) {
                clearTimeout(this.sendLock);
            }
            this.sendLock = setTimeout(() => {
                window.location = this.endpoint + payload;
            }, this.timer);
        },

        resetFilters() {
            const baseUrl = window.location.origin + window.location.pathname;
            window.location.href = baseUrl;
        }
    },
    mounted() {
        if (window.location.pathname === '/' && !sessionStorage.getItem('filtersApplied')) {
            this.applyFilter();
            sessionStorage.setItem('filtersApplied', 'true');
        }
    }
};
</script>
